import React from "react";
import "./CHRobinsonHelpModal.css";

const CHRobinsonHelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="chrobinson-help-modal-overlay" onClick={onClose}>
      <div
        className="chrobinson-help-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <h2>🚛 Get Your C.H. Robinson T-Number</h2>
        <div className="modal-content">
          <p className="intro">
            To book loads with C.H. Robinson, you'll need a T-Number. Here's how to get one:
          </p>

          <div className="step">
            <h3>
              <span className="step-number">1️⃣</span> Sign Up for C.H. Robinson through the Highway Platform
            </h3>
            <p>
              Visit <a href="https://highway.com/onboarding/sign-up" target="_blank" rel="noopener noreferrer">Highway's Sign Up Page</a> to sign up for a carrier account.
            </p>
            <p className="note">
              You will need to provide your MC and DOT numbers, verify your identity, and provide 
            </p>
          </div>

          <div className="step">
            <h3>
              <span className="step-number">2️⃣</span> Collect your T-Number
            </h3>
            <p>
              Once you register for CH Robinson through Highway, you will receive your T-Number in your email.
            </p>
          </div>

          <div className="step">
            <h3>
              <span className="step-number">3️⃣</span> Enter your T-Number here
            </h3>
            <p>Once you receive your T-Number, enter it in the field above to enable C.H. Robinson load booking.</p>
          </div>

          <div className="step">
            <h3>
              <span className="step-number">ℹ️</span> More Information
            </h3>
            <p>
              For more information, visit <a href="https://www.chrobinson.com/en-us/carriers/sign-up-and-book/" target="_blank" rel="noopener noreferrer">CH Robinson's Sign Up and Book Page</a>. For any questions on signing up on Highway, please contact <a href="mailto:service@highway.com">service@highway.com</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CHRobinsonHelpModal; 